module.exports = __webpack_public_path__ + "static/media/ideation-illustration-1d.f15b6686.svg";